import { Component } from '@angular/core';

import moment from 'moment-timezone';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor()
    {
        moment.tz.setDefault('America/Los_Angeles');
    }
}
